import { Button } from "@mui/material"
import { useIsDesktop } from "common/MediaQueries"
import { MODEL_IMAGE_INDEX } from "common/ModelImage"
import { useEffect, useState } from "react"
import CopyPopup from "reusable/finance/CopyPopup"
import { useTypedSelector } from "store"
import styled from "styled-components"
import { selectedColorSelector } from "../color/colorSelectors"
import { selectedDetailingSelector } from "../detailing/detailingSelectors"

const ShareButtonContainer = styled.div``

const StyledButton = styled(Button)`
  border: 2px solid black;
  padding: 8.25px 14px 8.25px 13px;
  border-radius: 3px;
`

type ShareIconProps = {
  className?: string
}

const ShareIcon = ({ className }: ShareIconProps) => (
  <img src="/icons/share-icon.svg" className={className} alt="שתפו את העמוד" />
)

const StyledShareIcon = styled(ShareIcon)`
  padding-left: 5px;
  height: 14px;
`

type ShareButtonProps = {
  className?: string
}

const ShareButton = ({ className }: ShareButtonProps) => {
  const [link, setLink] = useState("")
  const [copyPopupOpen, setCopyPopupOpen] = useState(false)
  const isDesktop = useIsDesktop()

  const detailing = useTypedSelector(selectedDetailingSelector)
  const color = useTypedSelector(selectedColorSelector)

  const desktopCopyText = `אפשר להעתיק ולשלוח את הלינק ל-${detailing?.details?.modelName} שלך
    כדי להתייעץ עם אחרים או כדי לחזור אחר כך`

  const mobileCopyText = `הרכבתי לעצמי ${detailing?.details?.modelName}:`

  useEffect(() => {
    if (window && window.location) setLink(window?.location?.href)
  }, [])

  const mobileShare = async () => {
    const imageUrl =
      color?.details.images[MODEL_IMAGE_INDEX].imageUrl ||
      detailing?.details.image.imageUrl
    const blob = await fetch(`${imageUrl}?width=600&bgcolor=white`).then((r) =>
      r.blob()
    )
    console.log(blob)
    navigator?.share?.({
      text: mobileCopyText,
      url: link,
      files: [
        new File([blob], "model.png", {
          type: blob.type,
        }),
      ],
    })
  }

  const openSharingPopup = () => {
    if (isDesktop) {
      setCopyPopupOpen(true)
    } else {
      mobileShare()
    }
  }

  return (
    <ShareButtonContainer className={className}>
      <StyledButton variant="outlined" onClick={() => openSharingPopup()}>
        <StyledShareIcon />
        שיתוף
      </StyledButton>

      <CopyPopup
        link={link}
        title="להתייעץ ולהחליט בראש שקט"
        copyText={desktopCopyText}
        setCopyPopupOpen={setCopyPopupOpen}
        buttonText="העתקת הלינק לשיתוף"
        copyPopupOpen={copyPopupOpen}
        customClose={() => {
          setCopyPopupOpen(false)
        }}
      />
    </ShareButtonContainer>
  )
}

export default ShareButton
